import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { notificationType } from '../../notificationType';
import { NotificationDropdownItem } from '../NotificationDropdownItem';
import * as S from './styled';

const MAX_ITEMS = 3;

function NotificationsDropdownGroup({
  name,
  type,
  themeSlug,
  notifications,
  unreadCount,
  setNotificationsOnRead,
}) {
  const [collapsed, setCollapsed] = useState(true);
  const total = notifications.length;
  const isCollapsable = total > MAX_ITEMS;
  const items = notifications.slice(0, collapsed ? MAX_ITEMS : total);
  const remaining = total - MAX_ITEMS;
  const isTheme = type === 'theme';

  function toggleCollapse() {
    setCollapsed(!collapsed);
  }

  return (
    <S.Container>
      <S.Title element="span" variant="five">
        {isTheme && themeSlug ? (
          <S.ThemeTitle themeSlug={themeSlug}>{name}</S.ThemeTitle>
        ) : (
          name
        )}
        <S.Count>({unreadCount})</S.Count>
      </S.Title>
      {items.map((item) => {
        return (
          <NotificationDropdownItem
            key={item.slug}
            setNotificationsOnRead={setNotificationsOnRead}
            type={type}
            {...item}
          />
        );
      })}
      {isCollapsable && collapsed && (
        <S.Toggle type="button" onClick={toggleCollapse}>
          Toon {remaining} meer van {name}
        </S.Toggle>
      )}
    </S.Container>
  );
}

NotificationsDropdownGroup.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['theme', 'brand']).isRequired,
  themeSlug: PropTypes.string,
  notifications: PropTypes.arrayOf(notificationType).isRequired,
  unreadCount: PropTypes.number.isRequired,
  setNotificationsOnRead: PropTypes.func,
};

export { NotificationsDropdownGroup };
